import { Container } from 'react-bootstrap';
import ArticleCarousel from './ArticleCarousel';

const RelatedArticles = ({ articles, topics }) => {
  if (!articles?.length) return null;

  return (
    <section className="related-articles-section" aria-labelledby="related-articles-heading">
      <Container>
        <h2 id="related-articles-heading" className="displayM bold color-primary-navyblue mb-5 text-start ps-2">
          {topics?.[0] ? `Latest from ${topics[0]}` : 'You may also be interested in:'}
        </h2>
        <ArticleCarousel id="carousel-suggested" articles={articles} />
      </Container>
    </section>
  );
};

export default RelatedArticles;
